export const doesResourceExist = async (url: string) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.ok) {
      return true
    } else {
      return false
    }
  } catch (e) {
    return false
  }
}
